
enum ListItemTypes {
  group,
  task,
}

interface IState {
  loadStatus: 'none' | 'loading' | 'loaded' | 'error',
  list: any[]
  tasks: any[]
  users: any[]
  colorCodes: any[]
  relations: any[]
  versions: any[]
  documents: any[]
  error: string
}

const initialState: IState = {
  loadStatus: 'none',
  list: [],
  tasks: [],
  users: [],
  colorCodes: [],
  relations: [],
  versions: [],
  documents: [],
  error: ''
}

const ProgrammationReducer = (state: IState = initialState, { type, payload, error }: any) => {

  const st = { ...state }

  if (type === 'PROGRAMMATION_LOAD_START') {

    st.loadStatus = 'loading'
  } else if (type === 'PROGRAMMATION_LOAD_END') {

    st.loadStatus = 'loaded'
    st.list = payload.list
    st.tasks = payload.tasks
    st.users = payload.users
    st.colorCodes = payload.colorCodes
    st.relations = payload.relations
    st.documents = payload.documents
    st.versions = payload.versions
  } else if (type === 'PROGRAMMATION_LOAD_ERROR') {

    st.loadStatus = 'error'
    st.error = error
  } else if (type === 'PROGRAMMATION_ADD_COLOR_CODE') {

    const colorCodes = st.colorCodes
    colorCodes.push(payload.colorCode)

    st.colorCodes = colorCodes
  } else if (type === 'PROGRAMMATION_UPDATE_COLOR_CODE') {

    const colorCodes = st.colorCodes.map((colorCode: any) => {

      if (colorCode._id === payload.colorCode._id) {

        return payload.colorCode
      }

      return colorCode
    })

    st.colorCodes = colorCodes
  } else if (type === 'PROGRAMMATION_ADD_TASK') {

    const tasks = [...st.tasks]
    tasks.push(payload.task)

    if (payload.parentTask) {

      const parentTaskIndex = tasks.findIndex((task: any) => task._id === payload.parentTask._id)

      tasks[parentTaskIndex] = payload.parentTask
    }

    st.tasks = tasks
    st.list = payload.list
    st.loadStatus = 'loaded'
  } else if (type === 'PROGRAMMATION_UPDATE_TASK') {

    const tasks = st.tasks.map((task: any) => {

      if (payload.task && `${task._id}` === `${payload.task._id}`) {

        return payload.task
      }

      if (payload.oldParentTask && `${task._id}` === `${payload.oldParentTask._id}`) {

        return payload.oldParentTask
      }

      if (payload.parentTask && `${task._id}` === `${payload.parentTask._id}`) {

        return payload.parentTask
      }

      return task
    })

    if (payload.list)
      st.list = payload.list

    st.tasks = tasks
    st.loadStatus = 'loaded'
  } else if (type === 'PROGRAMMATION_ADD_COST') {

    const tasks = st.tasks.map((task: any) => {

      if (task._id === payload.task_id) {

        task.resources = [...task.resources, payload.resource]
      }

      return task
    })

    st.tasks = tasks
    st.loadStatus = 'loaded'
  } else if (type === 'PROGRAMMATION_UPDATE_COST') {


    const tasks = st.tasks.map((task: any) => {

      if (task._id === payload.task_id) {

        const resources = task.resources.map((resource: any) => {

          if (resource._id === payload.resource._id) {

            return payload.resource
          }

          return resource
        })

        task.resources = resources
      }

      return task
    })

    st.tasks = tasks
    st.loadStatus = 'loaded'
  } else if (type === 'PROGRAMMATION_DELETE_COST') {

    const tasks = st.tasks.map((task: any) => {

      if (task._id === payload.task_id) {

        task.resources = task.resources.filter((resource: any) => resource._id !== payload.resource_id)
      }

      return task
    })

    st.tasks = tasks
    st.loadStatus = 'loaded'
  } else if (type === 'PROGRAMMATION_UPDATE_RELATIONS') {

    const { relation, oldFromTask, oldToTask, fromTask, toTask, addNewRelation = false } = payload

    const tasks = st.tasks.map((_task: any) => {

      if (oldFromTask && `${_task._id}` === `${oldFromTask._id}`) {

        return oldFromTask
      }

      if (oldToTask && `${_task._id}` === `${oldToTask._id}`) {

        return oldToTask
      }

      if (fromTask && `${_task._id}` === `${fromTask._id}`) {

        return fromTask
      }

      if (toTask && `${_task._id}` === `${toTask._id}`) {

        return toTask
      }

      return _task
    })

    const relations = st.relations.map((_relation: any) => {

      if (relation && `${_relation._id}` === `${relation._id}`) {

        return relation
      }

      return _relation
    })

    if (addNewRelation) {

      relations.push(relation)
    }

    st.tasks = tasks
    st.relations = relations
    st.loadStatus = 'loaded'
  } else if (type === 'PROGRAMMATION_DELETE_RELATION') {

    const { relation_id, oldFromTask, oldToTask, fromTask, toTask } = payload

    const tasks = st.tasks.map((_task: any) => {

      if (oldFromTask && `${_task._id}` === `${oldFromTask._id}`) {

        return oldFromTask
      }

      if (oldToTask && `${_task._id}` === `${oldToTask._id}`) {

        return oldToTask
      }

      if (fromTask && `${_task._id}` === `${fromTask._id}`) {

        return fromTask
      }

      if (toTask && `${_task._id}` === `${toTask._id}`) {

        return toTask
      }

      return _task
    })

    const relations = st.relations.filter((_relation: any) => _relation._id !== relation_id)

    st.tasks = tasks
    st.relations = relations
    st.loadStatus = 'loaded'
  } else if (type === 'PROGRAMMATION_UPDATE_CONSTRAINTS') {

    const { task, parentTask } = payload

    const tasks = st.tasks.map((_task: any) => {

      if (`${_task._id}` === `${task._id}`) {

        return task
      }

      if (parentTask && `${_task._id}` === `${parentTask._id}`) {

        return parentTask
      }

      return _task
    })

    st.tasks = tasks
    st.loadStatus = 'loaded'
  } else if (type === 'PROGRAMMATION_UPDATE_RESPONSIBLES') {

    const { task, parentTask } = payload

    const tasks = st.tasks.map((_task: any) => {

      if (`${_task._id}` === `${task._id}`) {

        return task
      }

      if (parentTask && `${_task._id}` === `${parentTask._id}`) {

        return parentTask
      }

      return _task
    })

    st.tasks = tasks
    st.loadStatus = 'loaded'
  } else if (type === 'PROGRAMMATION_ADD_DOCUMENT') {

    const documents = [...st.documents, payload.document]

    st.documents = documents
    st.loadStatus = 'loaded'
  } else if (type === 'PROGRAMMATION_UPDATE_DOCUMENT') {

    const documents = st.documents.map((document: any) => {

      if (document._id === payload.document_id) {

        return {
          ...document,
          name: payload.name
        }
      }

      return document
    })

    st.documents = documents
    st.loadStatus = 'loaded'
  } else if (type === 'PROGRAMMATION_DELETE_DOCUMENT') {

    const documents = st.documents.filter((document: any) => document._id !== payload.document_id)

    st.documents = documents
    st.loadStatus = 'loaded'
  } else if (type === 'PROGRAMMATION_SET_COMMENTS') {

    const tasks = st.tasks.map((task: any) => {

      if (`${task._id}` === `${payload.task_id}`) {

        task.comments = payload.comments
      }

      return task
    })

    st.tasks = tasks
    st.loadStatus = 'loaded'
  } else if (type === 'PROGRAMMATION_UPDATE_TASK_FIELD') {

    const {
      task_id,
      fieldName,
      value
    } = payload

    const tasks = st.tasks.map((task: any) => {

      if (`${task._id}` === `${task_id}`) {

        return {
          ...task,
          [fieldName]: value
        }
      }

      return task
    })

    st.tasks = tasks
  } else if (type === 'PROGRAMMATION_UPDATE_TASK_DATE') {

    const {
      updatedTask,
      parentTask
    } = payload

    const tasks = st.tasks.map((task: any) => {

      if (`${task._id}` === `${updatedTask._id}`) {

        return updatedTask
      }

      if (parentTask && `${task._id}` === `${parentTask._id}`) {

        return parentTask
      }

      return task
    })

    st.tasks = tasks
    st.loadStatus = 'loaded'
  } else if (type === 'PROGRAMMATION_ADD_GROUP') {

    st.list = payload.list
    st.loadStatus = 'loaded'
  } else if (type === 'UPDATE_GROUP_NAME') {

    const updateGroupName = (group_id: string, name: string, list: any[]) => {

      list = list.map((item: any) => {

        if (item.type === 'task') {

          return item
        }

        console.log('item', item.type)

        if (item.group._id === group_id) {

          return {
            ...item,
            group: {
              ...item.group,
              name
            }
          }
        }

        if (item.group.items.length) {

          item.group.items = updateGroupName(group_id, name, item.group.items)
        }

        return item
      })

      return list
    }

    st.list = updateGroupName(payload.group_id, payload.name, st.list)
  } else if (
    type === 'PROGRAMMATION_CONFIRM_REJECT_TASK' ||
    type === 'PROGRAMMATION_UPDATE_DISPLAY_MODE_TASK'
  ) {

    const tasks = st.tasks.map((task: any) => {

      if (task._id === payload.task._id) {

        return payload.task
      }

      if (payload.parentTask && `${task._id}` === `${payload.parentTask._id}`) {

        return payload.parentTask
      }

      return task
    })

    st.tasks = tasks
    st.loadStatus = 'loaded'
  } else if (
    type === 'PROGRAMMATION_COMPLETE_MANY' ||
            type === 'PROGRAMMATION_RESCHEDULE_MANY' ||
            type === 'PROGRAMMATION_RESTRICT_MANY' ||
            type === 'PROGRAMMATION_UPDATE_TASKS'
  ) {

    const tasks = st.tasks.map((task: any) => {

      const modified = payload.tasks.find((ft: any) => `${ft._id}` === `${task._id}`)

      if (modified) {

        return modified
      }

      return task
    })

    st.tasks = tasks
    st.loadStatus = 'loaded'
  } else if (type === 'PROGRAMMATION_UPDATE_LIST') {

    st.list = payload.list
    st.loadStatus = 'loaded'
  } else if (type === 'PROGRAMMATION_REMOVE_TASK') {

    st.list = payload.list

    const tasks = st.tasks.filter((task: any) => task._id !== payload.task_id)

    if (payload.parentTask) {

      const parentTaskIndex = tasks.findIndex((task: any) => task._id === payload.parentTask._id)

      tasks[parentTaskIndex] = payload.parentTask
    }

    st.tasks = tasks
    st.loadStatus = 'loaded'
  } else if (type === 'PROGRAMMATION_DELETE_GROUP') {

    st.list = payload.list
    st.tasks = st.tasks.filter((task: any) => !payload.deleted_tasks_ids.includes(task._id))
    st.loadStatus = 'loaded'
  } else if (type === 'PROGRAMMATION_CLEANUP') {

    st.loadStatus = 'none'
    st.list = []
    st.tasks = []
    st.users = []
    st.colorCodes = []
    st.relations = []
    st.versions = []
    st.error = ''
  }

  return st
}

export default ProgrammationReducer
